module.exports = __webpack_public_path__ + "img/login.1c9f062f.svg";